$(function() {
  $(".filter_btn").on("click", function() {
    if ($(this).hasClass("active")) {
      // すでにactiveなら閉じる
      $("#sort_menu").fadeOut();
      $(this).removeClass("active");
    } else {
      // activeじゃなければ開く
      $("#sort_menu").fadeIn();
      $(this).addClass("active");
    }
  });
});
